import styled, { css, keyframes } from 'styled-components';

const ICON_SIZE = 20;
const ARROW_WIDTH = 12;
const ARROW_HEIGHT = 6;
const ARROW_RIGHT_OFFSET = 19;
const TOOLTIP_RIGHT_SHIFT =
  ARROW_RIGHT_OFFSET + ARROW_WIDTH / 2 - ICON_SIZE / 2;

const appear = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const HintTooltipWrapper = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  margin-left: 8px;
`;

export const HintTooltipButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

export const hintPopoverHorizontalAlign = css`
  right: -${TOOLTIP_RIGHT_SHIFT}px;
`;

export const hintPopoverStyles = css`
  display: flex;
  align-items: flex-start;
  bottom: calc(100% + ${ARROW_HEIGHT + 2}px);
  max-width: 280px;
  padding: 8px 12px;
  border: 0;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.systemColors.black};
  animation: ${appear} 0.3s ease-out;

  &::before {
    content: '';
    position: absolute;
    top: 100%;
    right: ${ARROW_RIGHT_OFFSET}px;
    border-style: solid;
    border-width: ${ARROW_HEIGHT}px ${ARROW_WIDTH / 2}px 0;
    border-color: ${({ theme }) => theme.colors.systemColors.black} transparent
      transparent;
  }
`;
